import { useEffect, useState } from 'react';
import { messages } from 'i18n';
import Dialog from 'components/Dialog/Dialog';
import DialogContent from 'components/Dialog/DialogContent';
import DialogFooter from 'components/Dialog/DialogFooter';
import DialogHeader from 'components/Dialog/DialogHeader';
import DialogTextField from 'components/DialogTextField';

interface ApprovalReasonDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => Promise<void>;
  title: string;
  subtitle: string;
  placeholder: string;
  confirmLabel: string;
  isSubmitting: boolean;
  defaultReason?: string;
}

export default function ApprovalReasonDialog({
  isOpen,
  onCancel,
  onConfirm,
  title,
  subtitle,
  placeholder,
  confirmLabel,
  isSubmitting,
  defaultReason = '',
}: ApprovalReasonDialogProps) {
  const [reason, setReason] = useState(defaultReason);

  useEffect(() => {
    if (isOpen) {
      setReason(defaultReason);
    }
  }, [isOpen, defaultReason]);

  const handleCancel = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm(reason);
  };

  return (
    <Dialog open={isOpen} onClose={handleCancel} aria-labelledby="approval-reason-dialog-title" alertDialog>
      <DialogHeader title={title} subtitle={subtitle} id="approval-reason-dialog-title" onClose={handleCancel} />
      <DialogContent dividers={false} sx={{ mt: 1 }}>
        <DialogTextField placeholder={placeholder} value={reason} setValue={setReason} autoFocus multiline rows={3} />
      </DialogContent>
      <DialogFooter
        proceedButton={{
          children: confirmLabel,
          onClick: handleConfirm,
          loading: isSubmitting,
        }}
        cancelButton={{
          children: messages.buttons.cancel,
          onClick: handleCancel,
        }}
        disableElevation
      />
    </Dialog>
  );
}
